import { render, staticRenderFns } from "./tablePageTotal.vue?vue&type=template&id=0e0864ca&scoped=true&lang=pug"
import script from "./tablePageTotal.vue?vue&type=script&lang=js"
export * from "./tablePageTotal.vue?vue&type=script&lang=js"
import style0 from "./tablePageTotal.vue?vue&type=style&index=0&id=0e0864ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e0864ca",
  null
  
)

export default component.exports